export default "__VITE_ASSET__B6FFR56s__"